module.exports = __webpack_public_path__ + "img/blue_assessment.0a50d63d.svg";